import { writable } from 'svelte/store';
import { browser } from '$app/environment';

function createUiStore() {
	const { subscribe, update, set } = writable({
		isNoticeFormVisible: true,
		isSidebarOpen: false,
		scheduleDisplay: 'both'
	});

	return {
		subscribe,
		toggleNoticeForm: () =>
			update((state) => ({
				...state,
				isNoticeFormVisible: !state.isNoticeFormVisible
			})),
		setNoticeFormVisible: (isVisible) =>
			update((state) => ({
				...state,
				isNoticeFormVisible: isVisible
			})),
		toggleSidebar: () =>
			update((state) => ({
				...state,
				isSidebarOpen: !state.isSidebarOpen
			})),
		closeSidebar: () =>
			update((state) => ({
				...state,
				isSidebarOpen: false
			})),
		setScheduleDisplay: (mode) =>
			update((state) => ({
				...state,
				scheduleDisplay: mode
			}))
	};
}

export const uiStore = createUiStore();
